import React from 'react';
import { css } from 'aphrodite';
import styles from './button-styles';
import './button-loading-styles.css';
import { withRouter } from 'react-router-dom';
import buttonClick from './button-click';

const Button = (props) => (
  <div className={css(styles.root, props.loading && styles.rootLoading, props.disabled && styles.rootDisabled)} onClick={buttonClick(props)}>
    <div className={css(styles.title, props.loading && styles.titleLoading)}>{props.title}</div>
    {props.loading && <div className={'loading'} style={{ position: 'absolute', top: 3, texAlign: 'center' }}>
      <span>.</span><span>.</span><span>.</span>
    </div>}
  </div>
);

export default withRouter(Button);



// WEBPACK FOOTER //
// ./src/components/common/button/button.js